import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MetaClass } from './domain/meta-class';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MetaDataService {
  private http = inject(HttpClient);


  getMetaClass(entityClassName: string): Observable<MetaClass> {
    return this.http
      .get<MetaClass>('/api/meta/' + entityClassName)
      .pipe(map((meta) => Object.assign(new MetaClass(), meta)));
  }
}
